import { AttachedFileSortColumn } from 'models/index';

export function clampSortOrder(rawValue: string): ('asc' | 'desc') {
    if (rawValue === 'desc')
        return 'desc';
    return 'asc';
}
export function clampSortColumn(rawValue: string): AttachedFileSortColumn | undefined {
    if (rawValue === AttachedFileSortColumn[AttachedFileSortColumn.FileName])
        return AttachedFileSortColumn.FileName;
    if (rawValue === AttachedFileSortColumn[AttachedFileSortColumn.Size])
        return AttachedFileSortColumn.Size;
    return;
}
